// extracted by mini-css-extract-plugin
export default {"heading":"HelpCenter_heading__NYdHi","text":"HelpCenter_text__FFkr1","btn":"HelpCenter_btn__iC-Wz"};